<template>
  <button @click="$emit('click')" class="switch-button" :type="type" :data-active="active">
    {{text}}
    <span v-if="activeText" class="active-text">
      <span>{{ activeText }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: "switch-button",
  props: ["text", "activeText", "active", "type"]
}
</script>

<style lang="scss" scoped>
  $vertical-padding: 1.3em;
  $font-size: 14px;
  $height: calc(#{$font-size} + (#{$vertical-padding} * 2));
  $border-radius: calc(#{$height} / 2);
  $dot-size-adjust: 6px;

  .switch-button {
    display: inline-block;
    position: relative;
    line-height: 1;
    padding: $vertical-padding 1.5em $vertical-padding calc(#{$height} + 1.2em);
    border: none;
    border-radius: $border-radius;
    text-decoration: none;
    font-size: $font-size;
    background-color: $color-grey;
    text-align: left;
    color: $color-black;
    cursor: pointer;

    &:hover, &:focus, &:active {
      .active-text {
        background-color: $color-blue;
        color: $color-blue;
      }
    }

    &[data-active="true"] {
      .active-text {
        right: 0;
        background-color: $color-blue;
        color: $color-white;

        &:before {
          left: initial;

        }
      }
    }

    &:disabled {
      cursor: default;
    }

    .active-text {
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      right: 100%;
      min-width: $height;
      white-space: nowrap;
      padding: $vertical-padding 0;
      overflow: hidden;
      border-radius: $border-radius;
      background-color: $color-grey;
      color: $color-grey;

      transition: all 0.2s ease-in-out;

      span {
        padding-left: 1.5em;
      }

      &:before {
        content: " ";
        display: block;
        position: absolute;
        top: calc(#{$dot-size-adjust} / 2);
        right: calc(#{$dot-size-adjust} / 2);
        height: calc(#{$height} - #{$dot-size-adjust});
        width: calc(#{$height} - #{$dot-size-adjust});
        border-radius: 50%;
        background-color: $color-grey-dark;
      }
    }
  }
</style>
